// Imports related to application insights
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { runtimeConfig } from './runtimeConfig'

const browserHistory = createBrowserHistory()
const reactPlugin = new ReactPlugin()

const appInsights = new ApplicationInsights({
  config: {
    connectionString: runtimeConfig.VITE_APPINSIGHTS_INSTRUMENTATION_KEY || '',
    extensions: [reactPlugin],

    enableAutoRouteTracking: false,

    // Disable all automatic tracking - use custom logger for 100% control
    disableAjaxTracking: true,
    disableFetchTracking: true,
    disableExceptionTracking: true, // We'll handle exceptions manually

    autoTrackPageVisitTime: false,
    enableCorsCorrelation: false,
    enableRequestHeaderTracking: false,
    enableResponseHeaderTracking: false,

    // No sampling for custom events - 100% logging
    samplingPercentage: 100,
    maxAjaxCallsPerView: -1, // No limit on tracking calls

    correlationHeaderExcludedDomains: [
      'cdn.cookielaw.org',
      'js.monitor.azure.com',
      'assets.adobetm.com',
    ],

    extensionConfig: {
      [reactPlugin.identifier]: {
        history: browserHistory,
      },
    },
  },
})

try {
  if (runtimeConfig.VITE_APPINSIGHTS_INSTRUMENTATION_KEY) {
    appInsights.loadAppInsights()
  } else {
    console.warn('App Insights connection string not configured — telemetry disabled')
  }
} catch (error) {
  console.error('Failed to load App Insights:', error)
}

export default {
  appInsights,
  reactPlugin,
}

export { appInsights }
